export default __webpack_public_path__ + "static/02-17da77f177ed6bf9ea92b1fc6422883e.png";